import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports';

const oauthConfig = awsmobile.oauth || {};
const normalizeRedirects = (value, fallback = []) => {
  if (!value) return [...fallback];
  return Array.isArray(value) ? value : [value];
};

const graphQLConfig = {
  endpoint: awsmobile.aws_appsync_graphqlEndpoint,
  region: awsmobile.aws_appsync_region,
  defaultAuthMode: awsmobile.aws_appsync_authenticationType || 'AMAZON_COGNITO_USER_POOLS'
};

if (awsmobile.aws_appsync_authenticationType === 'API_KEY' && awsmobile.aws_appsync_apiKey) {
  graphQLConfig.apiKey = awsmobile.aws_appsync_apiKey;
}

const awsConfig = {
  Auth: {
    Cognito: {
      region: awsmobile.aws_project_region,
      userPoolId: awsmobile.aws_user_pools_id,
      userPoolClientId: awsmobile.aws_user_pools_web_client_id,
      identityPoolId: awsmobile.aws_cognito_identity_pool_id,
      loginWith: {
        oauth: {
          domain: oauthConfig.domain,
          scopes: oauthConfig.scope,
          redirectSignIn: normalizeRedirects(oauthConfig.redirectSignIn, [
            'http://localhost:3000/',
            'https://stu-studio.de/',
            'https://www.stu-studio.de/'
          ]),
          redirectSignOut: normalizeRedirects(oauthConfig.redirectSignOut, [
            'http://localhost:3000/',
            'https://stu-studio.de/',
            'https://www.stu-studio.de/'
          ]),
          responseType: oauthConfig.responseType,
          providers: ['Google', 'Facebook', 'SignInWithApple']
        }
      }
    }
  },
  API: {
    GraphQL: {
      ...graphQLConfig
    }
  },
  Storage: {
    S3: {
      bucket: awsmobile.aws_user_files_s3_bucket,
      region: awsmobile.aws_user_files_s3_bucket_region,
      defaultAccessLevel: 'public'
    }
  }
};

Amplify.configure(awsConfig);

export default awsConfig;